// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Avenir_0659c5'"},"className":"__className_0659c5"};